'use client';

import { Typography, styled } from '@mui/material';
import { Section, SectionColor } from '#components/Section/index.tsx';
import { tt } from '#i18n/index.ts';

export const FooterContainer = styled('div')({
  display: 'flex',
  minHeight: '300px',
});

export const Attribution = styled('div')({
  alignSelf: 'flex-end',
  justifySelf: 'flex-end',
});

export const Image = styled('img')(({ theme }) => ({
  display: 'block',
  height: '80px',
  marginBottom: theme.spacing(2),
}));

export const Footer = () => {
  return (
    <footer>
      <Section color={SectionColor.Grey}>
        <FooterContainer>
          <Attribution>
            <Image alt="The Movie Database (TMDB)" loading="lazy" src="/images/tmdb-logo.png" />
            <Typography sx={{ maxWidth: '500px' }} variant="body2">
              {tt('theMovieDb.disclaimer')}
            </Typography>
          </Attribution>
        </FooterContainer>
      </Section>
    </footer>
  );
};
